import React from "react";
import { Button, Chip, CircularProgress, DialogActions,} from "@material-ui/core";
import { makeStyles } from '@material-ui/core/styles';
import SaveIcon from "@material-ui/icons/Save";
import DeleteForeverOutlinedIcon from "@material-ui/icons/DeleteForeverOutlined"; 

const useStyles = makeStyles((theme) => ({
  chipContainer: {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    listStyle: 'none',
    padding: theme.spacing(0.5),
    margin: 0,
  },
  chip: {
    margin: theme.spacing(0.5),
  },
}));


function ChipSelection(props){
  const { role, selectedChips, handleRemoveChip, action, onSave, onReset, isLoading } = props;
  const classes = useStyles();
  const isActionView = action === 'View';

  const handleDelete = (chipToDelete) => () => {
    handleRemoveChip(chipToDelete);
  };

  const handleSubmit = () => {
    onSave();
  } 

  return (    
    <div className="user-selection-chips-container"> 
    {selectedChips.length > 0 && (
      <div className="user-selection-chips-container">            
        <div className={classes.chipContainer}>
          {selectedChips.map((data) => {
            return (
              <li key={data.id}>
                <Chip
                  label={data.email}
                  onDelete={handleDelete(data)}
                  className={classes.chip}
                />
              </li>
            );
          })}
        </div>
        
        <DialogActions className={classes.DialogActions} >
          <Button onClick={onReset} color="primary" variant="outlined" disabled={isLoading}     >
              Cancel
            </Button>
            <Button 
              type="submit"
              disabled={isLoading}           
              onClick={handleSubmit}
              color="primary" 
              autoFocus 
              variant="contained"
              startIcon={
                isLoading ? <CircularProgress size={24} /> : (isActionView ? <DeleteForeverOutlinedIcon/>: <SaveIcon />) 
              }
              >
                {isActionView ? "Remove" : "Assign"} {role}s
            </Button>
        </DialogActions>             
      </div>    
    )}
    </div>
  )

}

export default ChipSelection;